import React from "react";

import './styles.scss';

import MerchantNavigationItem from "./components/MerchantNavigationItem";
import {isUserAccessed} from "../../../../../emitters/account";

const permissionCheck = (el) => {
  const permissions = el.permissions || [];
  if (!permissions.length) return true;
  return permissions.every((pemission) => isUserAccessed(pemission));
}

const menuDisplayCtor = ({className, subLinksDisplayType}) => ({menu = [], onClick}) => (
  <nav className={className}>
    {menu
        .filter(permissionCheck)
        .map((el, i) => (
          <li key={i} className={`${className}__item`}>
            <MerchantNavigationItem
              {...el}
              subLinksDisplayType={subLinksDisplayType}
              onClick={onClick}
            />
          </li>
        ))
    }
  </nav>
);

export const NavigationHorizontal = menuDisplayCtor({
  className: 'nav-horizontal',
  subLinksDisplayType: 'dropdown'
});

export const NavigationVerticalMobile = menuDisplayCtor({
  className: 'nav-vertical-mobile',
  subLinksDisplayType: 'list'
});
